/**
 * Shared handler for mutation responses (create, update, delete, instantiate rules).
 * Branches on HTTP status 202 (maker-checker pending) vs 200 (applied).
 *
 * Returns { pending, changeRequestGuid, data } where:
 * - pending=true: 202 (awaiting approval), changeRequestGuid is the CR id
 * - pending=false: 200 (applied immediately), data is the response payload
 */
export function handleMutationResponse(response) {
  if (response.status === 202) {
    return {
      pending: true,
      changeRequestGuid: response.data.change_request_guid,
      data: null
    }
  }
  return {
    pending: false,
    changeRequestGuid: null,
    data: response.data
  }
}
